import { ActionType } from '../../types';

export const MeshDeviceActions = {
    meshGatewayDeviceRegistrationStarted: () =>
        ({
            type: 'MeshGatewayDevice/Registration/Started',
        } as const),

    meshGatewayDeviceRegistrationSucceeded: (message: string, data: {}) =>
        ({
            type: 'MeshGatewayDevice/Registration/Succeeded',
            payload: { message, data},
        } as const),

    meshGatewayDeviceRegistrationFailed: (errorCode: string) =>
        ({
            type: 'MeshGatewayDevice/Registration/Failed',
            payload: { errorCode },
        } as const),

    meshGatewayDeviceRegistrationUnmounted: () =>
        ({
            type: 'MeshGatewayDevice/Registration/Unmounted',
        } as const),

    meshGatewayDeviceMasterData: (hasData: boolean) =>
        ({
            type: 'MeshGatewayDevice/MasterData/Failed',
            payload: { hasData },
        } as const),

};

export type MeshDeviceActions = ActionType<typeof MeshDeviceActions>;
